





















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Mutation } from 'vuex-class'
import NumberInput from '@/components/form/NumberInput.vue'
import BasketSectionHeader from '@/components/BasketSectionHeader.vue'
import ProductImage from '@/components/ProductImage.vue'
import { Product, Discount, DiscountOp } from '../store/types'
import config from '@/config'

@Component({
	components: {
		NumberInput,
		BasketSectionHeader,
		ProductImage,
	},
})
export default class ProductItem extends Vue {
	@Prop() readonly product!: Product
	@Prop() readonly discount!: Discount

	@Mutation private setProductCount!: (payload: { id: string, count: number }) => void

	private readonly counterEnabled: boolean = config.productCounterEnabled

	private get isDiscount(): boolean {
		return new DiscountOp(this.discount).isDiscountForProduct(this.product)
	}

	private get productPriceOriginal100(): number {
		return this.product.price100
	}

	private get productPrice100(): number {
		return new DiscountOp(this.discount).computeProductPriceSingle(this.product)
	}

	private get productPriceCount100(): number {
		return new DiscountOp(this.discount).computeProductPriceCount(this.product)
	}

	onCountChange(count: number) {
		const { id } = this.product
		this.setProductCount({ id, count })
	}
	onDelete() {
		this.$emit('delete', this.product)
	}
}
